$('.js-image').click(function() {
    $('.js-image-placeholder').attr('src', $(this).attr('data-original-src'));
    $('.js-image-popup').show();
});

$('.js-image-popup').click(function() {
    $(this).hide();
})
